import { UserInfo } from '../models/interfaces';
import { Action, ActionTypes } from '../actions';

export default (state: UserInfo, action: Action) => {
  switch (action.type) {
    case ActionTypes.fetchUserInfo:
      console.log('ActionTypes.fetchUserInfo');
      return {
        ...state,
        symptoms: { ...action.payload.symptoms },
        contacts: { ...action.payload.contacts },
        statistics: action.payload.statistics,
      };
    case ActionTypes.toggleSymptom:
      console.log('ActionTypes.toggleSymptom');
      return {
        ...state,
        symptoms: action.payload,
      };
    case ActionTypes.addNewContact: {
      console.log('ActionTypes.addNewContact');
      const contact = action.payload;
      const newState = { ...state };
      newState.contacts[contact.userId] = contact;
      return newState;
    }
    case ActionTypes.deleteContact: {
      console.log('ActionTypes.deleteContact');
      const contactId = action.payload;
      const newState = { ...state };
      delete newState.contacts[contactId];
      return newState;
    }
    default:
      return state;
  }
};
